export default __webpack_public_path__ + "static/media/folder.bd07f550.png";